import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faUserPlus, faEnvelope, faEye } from "@fortawesome/free-solid-svg-icons";

import Utils from "../../configs/Utils";
import PopupModal from "../Common/Popup";
import WorkspaceMemberForm from "./WorkspaceMemberForm";

const WorkspaceListItem = ({ ...props }) => {
  const { index, workspace, workspaceList, setWorkspaceList } = props;
  const [memberPopupShow, setMemberPopupShow] = useState(false);

  return (
    <>
      <tr>
        <td>{index + 1}</td>
        <td>
          <Link to={`/workspace/${workspace._id}`} className="text-decoration-none">
            <strong>{workspace.name}</strong>
          </Link>
        </td>
        <td>{workspace.description || "-"}</td>
        <td>
          {(() => {
            const displayName =
              workspace.owner?.fullName ||
              workspace.owner?.email ||
              workspace.owner ||
              "Unknown";
              
            const initial = typeof displayName === 'string' ? displayName.charAt(0).toUpperCase() : "U";
            const bgColor = typeof displayName === 'string' ? Utils.stringToColor(displayName) : "#6c757d";

            return (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-owner-${workspace._id}`}>
                    {typeof displayName === 'string' ? displayName : "Unknown"}
                  </Tooltip>
                }
              >
                <div
                  className="rounded-circle text-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: bgColor,
                    fontSize: "14px",
                    fontWeight: "bold",
                    border: "2px solid #fff",
                  }}
                >
                  {initial}
                </div>
              </OverlayTrigger>
            );
          })()}
        </td>
        <td>
          <div className="d-flex align-items-center">
            {workspace.members && workspace.members.length > 0 ? (
              workspace.members.slice(0, 5).map((member, idx) => {
                const userObj = member.user;
                // Using email as fallback for initial if fullName not available
                const displayName =
                  userObj?.fullName || member.email || "Unknown User";
                const initial = displayName.charAt(0).toUpperCase();
                const bgColor = Utils.stringToColor(displayName);

                return (
                  <OverlayTrigger
                    key={idx}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-${workspace._id}-${idx}`}>
                        {displayName}
                      </Tooltip>
                    }
                  >
                    <div
                      className="rounded-circle text-white d-flex align-items-center justify-content-center me-1"
                      style={{
                        width: "32px",
                        height: "32px",
                        backgroundColor: bgColor,
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "2px solid #fff",
                        marginLeft: idx > 0 ? "-10px" : "0",
                      }}
                    >
                      {initial}
                    </div>
                  </OverlayTrigger>
                );
              })
            ) : (
              <span className="text-muted">No members</span>
            )}
            {workspace.members && workspace.members.length > 5 && (
              <div
                className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                  fontSize: "12px",
                  border: "2px solid #fff",
                  marginLeft: "-10px",
                  zIndex: 0,
                }}
              >
                +{workspace.members.length - 5}
              </div>
            )}
          </div>
        </td>
        <td>
          {workspace.createdAt
            ? Utils.dateFormat(workspace.createdAt, true)
            : "-"}
        </td>
        <td className="text-inline text-end">
          <Link to={`/workspace/${workspace._id}/mailtemplate`}>
            <Button
              className="ms-1"
              size="sm"
              variant="outline-info"
              title="Mail Templates"
            >
              <FontAwesomeIcon icon={faEnvelope} />
            </Button>
          </Link>
          <Button
            className="ms-1"
            size="sm"
            variant="outline-primary"
            title="Add Member"
            onClick={() => setMemberPopupShow(true)}
          >
            <FontAwesomeIcon icon={faUserPlus} />
          </Button>
          <Link to={`/workspace/${workspace._id}`}>
            <Button
              className="ms-1"
              size="sm"
              variant="outline-secondary"
              title="View Details & Manage"
            >
              <FontAwesomeIcon icon={faEye} />
            </Button>
          </Link>
        </td>
      </tr>

      <PopupModal
        title={`Add Member to ${workspace.name}`}
        popupShow={memberPopupShow}
        setPopupShow={setMemberPopupShow}
      >
        <WorkspaceMemberForm
          workspaceId={workspace._id}
          setPopupShow={setMemberPopupShow}
        />
      </PopupModal>
    </>
  );
};

export default WorkspaceListItem;
